import React from 'react';
import {
    LineChart as RechartsLineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend
} from 'recharts';
import './LineChart.scss';

const LineChart = ({
    data = [],
    dataKey = 'value',
    xAxisKey = 'date',
    lines = [{ key: 'value', color: '#FF3232', name: 'Value' }],
    height = 300,
    showGrid = true,
    showTooltip = true,
    showLegend = false,
    yAxisLabel,
    xAxisLabel,
    formatTooltip,
    loading = false
}) => {
    if (loading) {
        return (
            <div className="chart-loading" style={{ height: `${height}px` }}>
                <div className="loading-skeleton"></div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="chart-empty" style={{ height: `${height}px` }}>
                <p>No data available</p>
            </div>
        );
    }

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <p className="tooltip-label">{label}</p>
                    {payload.map((entry, index) => (
                        <p key={index} style={{ color: entry.color }}>
                            {entry.name}: {formatTooltip ? formatTooltip(entry.value) : entry.value}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <div className="line-chart-container">
            <ResponsiveContainer width="100%" height={height}>
                <RechartsLineChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                    {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />}
                    <XAxis 
                        dataKey={xAxisKey} 
                        stroke="#666"
                        tick={{ fontSize: 12 }}
                        label={xAxisLabel ? { value: xAxisLabel, position: 'insideBottom', offset: -5 } : null}
                    />
                    <YAxis 
                        stroke="#666"
                        tick={{ fontSize: 12 }}
                        label={yAxisLabel ? { value: yAxisLabel, angle: -90, position: 'insideLeft' } : null}
                    />
                    {showTooltip && <Tooltip content={<CustomTooltip />} />}
                    {showLegend && <Legend />}
                    {lines.map((line, index) => (
                        <Line
                            key={line.key || index}
                            type="monotone"
                            dataKey={line.key}
                            stroke={line.color}
                            strokeWidth={2}
                            name={line.name}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                        />
                    ))}
                </RechartsLineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default LineChart;





